import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AllService } from '../../rest/all.service';
import { GlobalService } from '../../global/global.service';
import { SupplierService } from '../../rest/Supplier.service';
import * as $ from 'jquery';
import { UserSelected } from "../notifications";
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { BackService } from '../../rest-model/back.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers: [AllService, GlobalService, SupplierService, BackService]
})
export class SidebarComponent implements AfterViewInit, OnInit {
  isActive: Boolean = true;
  sidebarList: Array<any> = [];
  showMenu: String = '';
  showSubMenu: String = '';
  userSelected = new UserSelected;
  jwtToken : String = '';

  companySelected = {
    Id_Company: 0,
    Status: '',
    Id_Supplier_Data: 0,
    CompanyName: '',
    RFC: '',
    EMAIL: '',
    LogoURL: '',
    Activo: 'false'
  };
  code: any;
  errorIn: any;
  Supplier_Validity_Fiscal_Opinion = {
    Block: 'F',
    Active: 'V'
  };

  constructor(
    private router: Router,
    private toastr: ToastsManager,
    private globalService: GlobalService,
    private supplierService: SupplierService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private allService: AllService,
    private backEndServices : BackService
    ) {
    if (localStorage.getItem('languaje') === 'es') {
      translate.use('es');
    } else if (localStorage.getItem('languaje') === 'en') {
      translate.use('en');
    } else {
      translate.setDefaultLang('es');
      localStorage.setItem('languaje', String('es'));
    }

    this.jwtToken = localStorage.getItem('jwt');

      if(this.jwtToken.length> 0){

        this.getUserByTokenSerivice();
        this.getSidebarService();

      }else { //Check JWT

          this.backEndServices.GetTokenJWT({
          appToken:environment.AppToken,
          LoginToken:localStorage.getItem('key'),
          enviroment: environment.Ambiente,
        }).then(res=>{
        if (res.code == 1){

              localStorage.setItem('jwt',res.message)
              this.getUserByTokenSerivice();
              this.getSidebarService();
            }

        });



      }

    this.supplierCompaActiveService();
    this.Supplier_Validity_Fiscal_OpinionService();

    this.translate.get('GENERAL.code').subscribe((res: string) => {
    this.code = res;
    });
    this.translate.get('GENERAL.errorIn').subscribe((res: string) => {
      this.errorIn = res;
    });
  }
  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setActiveByUrl(event.urlAfterRedirects);
      }
    });

    // También al iniciar
    this.setActiveByUrl(this.router.url);
  }
  setActiveByUrl(currentUrl: string) {
    // Busca coincidencia con Developer_Code en el menú principal
    for (let menu of this.sidebarList) {
      if (currentUrl.includes(menu.Developer_Code)) {
        this.showMenu = menu.Developer_Code;

        // Verifica también submenús
        if (menu.SubMenus) {
          for (let sub of menu.SubMenus) {
            if (currentUrl.includes(sub.Developer_Code)) {
              this.showSubMenu = sub.Developer_Code;
              break;
            }
          }
        }

        break;
      }
    }
  }
  addExpandClass(element: any) {
    if (element === this.showMenu) {
      this.showMenu = '0';
    } else {
      this.showMenu = element;
    }
  }
  addActiveClass(element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = '0';
    } else {
      this.showSubMenu = element;
    }
  }
  eventCalled() {
    this.isActive = !this.isActive;

  }
  // End open close
  ngAfterViewInit() {
    this.supplierCompaActiveService();
/* 
    $(function () {

      $(".sidebartoggler").on('click', function () {
        if ($("body").hasClass("mini-sidebar")) {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow", "hidden").parent().css("overflow", "visible");
          $("body").removeClass("mini-sidebar");
          $('.navbar-brand .expandMenu').show();
          $('.navbar-brand .contractMenu').hide();
          //$(".sidebartoggler i").addClass("ti-menu");
        }
        else {
          $("body").trigger("resize");
          $(".scroll-sidebar, .slimScrollDiv").css("overflow-x", "visible").parent().css("overflow", "visible");
          $("body").addClass("mini-sidebar");
          $('.navbar-brand .expandMenu').hide();
          $('.navbar-brand .contractMenu').show();
          //$(".sidebartoggler i").removeClass("ti-menu");
        }
      });

    }); */
  }

  profile() {
    const redirect = '/profile';
    this.router.navigate([redirect]);
  }

  connectionNew(link){
    const redirect = link;
    window.open(redirect, '_blank');
  }

 async getUserByTokenSerivice() {

    await  this.backEndServices.post_async( {
      entidad: "User",
      funcion: 8,
      data:{}


    } ).then(res => {
     // console.log(res);
          if(res.result){
            this.userSelected = res.data;
          }


    }).catch(error => {
      // console.log(error);
      // this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      // this.spinner.hide();
      this.globalService.redirectWeb_SSO();

    });


//     this.allService.getUserByToken().subscribe(resp => {
//       if (this.globalService.verifyResponse(resp)) {
//         this.userSelected = resp;
//       }
//     },
//     (error)=>{
//       this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
// this.spinner.hide();
//     });
  }

  getSidebarService() {

    this.backEndServices.post_async( {
      entidad: "User",
      funcion:32,
      data:{
        Id_Tag: environment.Id_Tag,
        AppToken: environment.AppToken
      }

    } ).then(res => {

          if(res.result){
            this.sidebarList = res.data;
          }


    }).catch(error=> {
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
      this.spinner.hide();

    });


//     this.allService.getSidebar().subscribe(resp => {
//       if (this.globalService.verifyResponse(resp)) {
//         this.sidebarList = resp[0].SubMenus;
//       }
//     },
//     (error)=>{
//       this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
// this.spinner.hide();
//     });
  }

  logoutService() {



//     this.allService.logout().subscribe(resp => {
//       localStorage.setItem('key', '');
//       localStorage.setItem('compaNotif', '');
//       //localStorage.removeItem('companySelectedLocalName');
//       //localStorage.setItem('companySelectedLocalDisaled', '');
//       //localStorage.setItem('companySelectedLocal', '');
//       const redirect = '/';
//       this.router.navigate([redirect]);
//     },
//     (error)=>{
//       this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
// this.spinner.hide();
//     });
  }

  supplierCompaActiveService() {
    this.allService.supplierCompaActive().subscribe(resp => {
      if (this.globalService.verifyResponse(resp)) {
        // this.toastr.success('Se ha eliminado correctamente.', 'Enviado', { toastLife: 10000, showCloseButton: true });

        this.companySelected = resp;
        // this.Id_Supplier_Data = resp.Id_Supplier_Data;
      }
    },
    (error)=>{
      this.toastr.error(this.errorIn + '<br />' + this.code + ': ' + error.status + '.<br />' + error.statusText, 'Error', { dismiss: 'click', showCloseButton: true, enableHTML: true });
this.spinner.hide();
    });
  }

  Supplier_Validity_Fiscal_OpinionService() {
    this.supplierService.Supplier_Validity_Fiscal_Opinion().subscribe(resp => {
      if (this.userSelected.UserType === 'S') {
        this.Supplier_Validity_Fiscal_Opinion = resp;
        // const redirect = '/supplier/edit';
        // this.router.navigate([redirect]);

      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/sidebar/sidebar.component.ts